namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoTypeRow {
        Id?: number;
        PmType?: number;
        PmTypeDesc?: string;
        PmTypeOrder?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace PsAdvPromoTypeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmTypeDesc';
        export const localTextPrefix = 'AdvPromo.PsAdvPromoType';
        export const lookupKey = 'AdvPromo.PsAdvPromoType';

        export function getLookup(): Q.Lookup<PsAdvPromoTypeRow> {
            return Q.getLookup<PsAdvPromoTypeRow>('AdvPromo.PsAdvPromoType');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            PmType = "PmType",
            PmTypeDesc = "PmTypeDesc",
            PmTypeOrder = "PmTypeOrder",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
